import { DisplayMode } from '@mfe/config';
import { property, State } from '@mfec/lit/store';
import { Purpose } from '@mfec/types/model';

export class ComponentStateStore extends State {
  [key: string | symbol]: unknown;

  @property({ value: false }) disabled!: boolean;

  @property({ value: DisplayMode.view }) displayMode!: DisplayMode;

  @property({ value: undefined }) activePurpose!: Purpose;
}

export const store = new ComponentStateStore();
